import { buildAckStart, buildPractice, buildCheck } from '../fixtures/practice';
import { mockError } from '../mockError';

// Acknowledgement page routes, as called through the BFF whitelist (server/whitelist.js).
// /ack-of-receipt/fr/demo-<family> picks the mock family; demo-error-<key> answers an ack-start refusal
// (e.g. demo-error-ack.key.used), demo-expire-<family> answers a session expiry on practice / check / ack.
const errorKeyOf = (ackToken) => {
  const match = /^demo-error-(.+)$/.exec(String(ackToken || ''));
  return match ? match[1] : null;
};

const sessionExpired = () => mockError(400, { errors: [{ key: 'ack.key.session.expired' }] });

const familyToken = (ackToken) => String(ackToken || '').replace(/^demo-expire-/, 'demo-');
const expires = (ackToken) => /^demo-expire-/.test(String(ackToken || ''));

const conventionsHandlers = [
  // POST /ack-api/conventions/:language/ack-start?ackToken=
  {
    method: 'POST',
    pattern: /^\/ack-api\/conventions\/(fr|en)\/ack-start\/?$/,
    handler: ({ match, params }) => {
      const key = errorKeyOf(params.ackToken);
      if (key) throw mockError(key === 'ack.key.not.found' ? 404 : 400, { errors: [{ key }] });
      return buildAckStart(familyToken(params.ackToken), match[1]);
    },
  },
  // GET /ack-api/conventions/:language/ack/practice?ackToken=&mode=EXAMPLE|EXERCISE
  {
    method: 'GET',
    pattern: /^\/ack-api\/conventions\/(fr|en)\/ack\/practice$/,
    handler: ({ match, params }) => {
      if (expires(params.ackToken) && params.mode === 'EXERCISE') throw sessionExpired();
      return buildPractice(familyToken(params.ackToken), match[1], params.mode);
    },
  },
  // POST /ack-api/conventions/:language/ack/practice/check?ackToken=  { practiceId, answer }
  {
    method: 'POST',
    pattern: /^\/ack-api\/conventions\/(fr|en)\/ack\/practice\/check$/,
    handler: ({ match, params, body }) => {
      if (expires(params.ackToken)) throw sessionExpired();
      const result = buildCheck(familyToken(params.ackToken), match[1], body || {});
      if (!result) throw mockError(400, { status: 400, error: 'invalid practice request' });
      return result;
    },
  },
  // PUT /ack-api/conventions/ack?ackToken=
  {
    method: 'PUT',
    pattern: /^\/ack-api\/conventions\/ack$/,
    handler: ({ params }) => {
      if (expires(params.ackToken)) throw sessionExpired();
      return null;
    },
  },
];

export default conventionsHandlers;
